import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  DEFAULT_DELIVERY_SETTINGS,
  getDeliverySettings,
} from "../api/siteSettingsApi";

const DeliverySettingsContext = createContext({
  settings: DEFAULT_DELIVERY_SETTINGS,
  loading: true,
  error: "",
  reload: async () => DEFAULT_DELIVERY_SETTINGS,
});

export const DeliverySettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_DELIVERY_SETTINGS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const next = await getDeliverySettings();
      setSettings(next);
      setError("");
      return next;
    } catch (requestError) {
      setError("Не вдалося оновити налаштування доставки.");
      return DEFAULT_DELIVERY_SETTINGS;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const value = useMemo(
    () => ({ settings, loading, error, reload }),
    [settings, loading, error, reload]
  );

  return (
    <DeliverySettingsContext.Provider value={value}>
      {children}
    </DeliverySettingsContext.Provider>
  );
};

export const useDeliverySettings = () => useContext(DeliverySettingsContext);
